import { render, staticRenderFns } from "./EpiLayoutForCustomer.vue?vue&type=template&id=659c35ee"
import script from "./EpiLayoutForCustomer.vue?vue&type=script&lang=js"
export * from "./EpiLayoutForCustomer.vue?vue&type=script&lang=js"
import style0 from "./EpiLayoutForCustomer.vue?vue&type=style&index=0&id=659c35ee&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports